var _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg400(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.5,122.77a12.4,12.4,0,0,1-13.81-16.43L604,39.14a12.3,12.3,0,0,1,9.48-8h0a12.27,12.27,0,0,1,11.62,4.23L671.17,90a12.4,12.4,0,0,1-7.3,20.2l-70.34,12.57Zm20.63-88h0a8.57,8.57,0,0,0-6.64,5.6l-24.29,67.2a8.7,8.7,0,0,0,9.69,11.52h0l70.34-12.58a8.69,8.69,0,0,0,5.12-14.16L622.28,37.75A8.6,8.6,0,0,0,614.13,34.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.16,97.72a4.58,4.58,0,0,1,3.89-5.35,4.59,4.59,0,1,1,1.65,9A4.63,4.63,0,0,1,620.16,97.72ZM613.87,61l8.61-1.57L626,87,620.25,88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.36,373.85c-13.93-19.8-9.39-45.52-.76-67,1.44-3.59,2.43-7.56,5.31-10.12s7.7-3.27,10.4-.56c2.23,2.25,2.27,5.81,2.84,8.95a22.5,22.5,0,0,0,5.56,11.22c1.88,2,4.47,3.81,7.21,3.37,3.75-.59,5.69-4.78,7-8.4l7.2-20.23c1.28-3.62,2.61-7.31,5-10.32s6-5.31,9.78-5,7.31,3.8,6.76,7.6c-.24,1.58-1.09,3-1.53,4.53s-.35,3.45.92,4.38,3.11.45,4.57-.22c5-2.29,9.28-6.07,13.34-9.88s8.08-7.76,12.9-10.51,10.65-4.21,15.92-2.62,9.63,6.77,9.1,12.32-5.38,9.65-10.11,12.6a86,86,0,0,1-22.58,9.91c-1.43.39-3,.82-3.9,2-1.66,2.13-.24,5.34,1.85,7,2.36,1.87,5.38,2.65,8.08,4s5.29,3.7,5.39,6.75c.14,4.23-4.35,7-8.3,8.41a73.72,73.72,0,0,1-24.71,4.38c-3,0-6.11-.16-8.93.93s-5.29,3.87-4.92,6.88,3.4,5,6.37,5.53,6-.12,9-.16c5.64-.07,11.92,2.6,13.54,8,1.07,3.57-.17,7.57-2.45,10.54a27.8,27.8,0,0,1-8.71,6.94c-11.33,6.44-24.24,10.26-37.19,10.08s-24-3-33.93-11.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.91,362.26a344,344,0,0,1,25.48-30.17l7.08-7.57c2.33-2.48,4.64-4.93,7-7.2a172,172,0,0,1,14.59-12.21c4.83-3.66,9.55-7,14-10s8.63-5.8,12.55-8.15A137.92,137.92,0,0,1,704,277.24c2.37-1,4.23-1.65,5.49-2.1l1.45-.5a1.67,1.67,0,0,1,.5-.14l-.48.21-1.42.57c-1.25.49-3.09,1.22-5.43,2.22a144.84,144.84,0,0,0-19.19,9.88c-3.9,2.37-8.07,5.15-12.48,8.21s-9.11,6.38-13.92,10a175.1,175.1,0,0,0-14.5,12.2c-2.4,2.26-4.68,4.69-7,7.18l-7.08,7.56a352.58,352.58,0,0,0-25.47,30.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.72,317.37a8.39,8.39,0,0,1,.21-1.67c.17-1.07.47-2.6.87-4.49.79-3.78,2.07-9,3.49-14.67s2.63-10.9,3.36-14.68c.37-1.89.66-3.42.84-4.48a7.37,7.37,0,0,1,.37-1.64,7.78,7.78,0,0,1-.09,1.67c-.11,1.08-.32,2.63-.63,4.54-.61,3.81-1.73,9-3.16,14.76l-3.69,14.61c-.44,1.76-.8,3.24-1.09,4.43A7.39,7.39,0,0,1,643.72,317.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.28,325.53a10.82,10.82,0,0,1-1.93-.45c-1.23-.33-3-.81-5.22-1.33-4.41-1.08-10.57-2.37-17.42-3.49s-13.1-1.84-17.64-2.24c-2.27-.22-4.1-.35-5.37-.44a10.7,10.7,0,0,1-2-.21,10.72,10.72,0,0,1,2-.07c1.28,0,3.13.06,5.4.22,4.56.27,10.84.93,17.72,2a174.43,174.43,0,0,1,17.43,3.7c2.2.59,4,1.14,5.17,1.55A10,10,0,0,1,693.28,325.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.79,361.61a2.86,2.86,0,0,1-.11-.68c0-.53-.11-1.18-.18-2-.16-1.71-.31-4.19-.47-7.25-.31-6.13-.47-14.61-.52-24s-.14-17.84-.32-24c-.1-3-.18-5.44-.24-7.26,0-.79,0-1.44-.05-2a3.08,3.08,0,0,1,0-.69,3,3,0,0,1,.11.68c.05.54.11,1.18.19,2,.15,1.71.31,4.19.46,7.25.31,6.13.47,14.61.53,24s.13,17.83.31,24c.1,3,.18,5.43.24,7.25,0,.79,0,1.44.05,2A2.06,2.06,0,0,1,604.79,361.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.68,364.11a3.14,3.14,0,0,1-.7,0l-2-.05-7.38-.26c-6.23-.21-14.85-.41-24.36-.62s-18.14-.48-24.37-.82c-3.11-.17-5.63-.34-7.37-.48l-2-.19a3.07,3.07,0,0,1-.7-.11,3.36,3.36,0,0,1,.71,0l2,.05,7.38.25c6.23.22,14.84.42,24.36.62s18.13.48,24.36.83c3.12.17,5.64.33,7.38.48l2,.18A2.12,2.12,0,0,1,673.68,364.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.77,83.78s-9.4,3.81,1.44,23.77,18.26,29.79,18.26,29.79,2,4.65-2,5.48-12.68-.33-14.31,4.55c-1.7,5.06,2.07,9.7,9.56,13.66s23.6,13.24,25.05,14.08,2.9,3,.31,4S73,182.64,74.75,191.83s24.46,16.79,26.92,17.67,3.08,1.9,2.91,3.24-6.8,1.59-12.33,2.54-11.76,3-10.3,8.24S97,239.43,129.44,241.76l15.09.1,7.88-13C167.58,200.16,165.7,183,162,179s-8.71.19-12.44,4.38-7.45,9.69-8.67,9.12-1.77-1.63-1.22-4.18,6.11-25.84-.75-32.2-19.36,8.86-21.58,10.53-3.26-.71-3.21-2.36.69-20.25,1.3-28.71-1.34-14.1-6.54-15.34c-5-1.2-8.64,6.84-11.43,9.74s-5.7-1.22-5.7-1.22-4.42-11.49-15.63-31.25-19.58-13.6-19.58-13.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.41,245.39c-8.18-14.55-22.27-40.64-34.48-63s-23.28-42.54-31.38-57.13L69.94,108l-2.61-4.69-.66-1.23c-.15-.28-.22-.43-.22-.43a4.42,4.42,0,0,1,.26.4l.71,1.21,2.68,4.65c2.33,4,5.66,9.92,9.74,17.19,8.17,14.55,19.29,34.73,31.5,57.06s26.26,48.46,34.36,63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.34,149.49a4.78,4.78,0,0,1,1.06.26c.67.2,1.63.52,2.82.91,2.38.81,5.63,2,9.2,3.38l9.12,3.57,2.77,1.06a5.22,5.22,0,0,1,1,.43,4.65,4.65,0,0,1-1.06-.26c-.68-.2-1.64-.51-2.83-.92-2.37-.83-5.6-2.06-9.17-3.44L76.11,151l-2.77-1A5.15,5.15,0,0,1,72.34,149.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.31,158.11c-.12,0,2-6.86,4.83-15.22s5.15-15.12,5.28-15.08-2,6.86-4.83,15.22S99.44,158.15,99.31,158.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.52,193.26a5,5,0,0,1,.59-.95l1.72-2.49c1.45-2.11,3.45-5,5.53-8.32s3.87-6.34,5.15-8.55c.6-1,1.11-1.92,1.51-2.63a6.11,6.11,0,0,1,.6-.94,5,5,0,0,1-.44,1c-.31.64-.78,1.57-1.38,2.7-1.21,2.26-3,5.34-5.05,8.64s-4.13,6.2-5.65,8.26c-.76,1-1.39,1.85-1.84,2.41A5.28,5.28,0,0,1,116.52,193.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,190.83a4.89,4.89,0,0,1,1,0l2.8.15c2.36.15,5.62.38,9.21.67s6.85.57,9.21.8l2.78.3a4.66,4.66,0,0,1,1,.17,3.62,3.62,0,0,1-1,0l-2.8-.15c-2.36-.14-5.62-.38-9.21-.67s-6.85-.57-9.21-.8l-2.78-.3A4.66,4.66,0,0,1,90.4,190.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.65,223.79a6.38,6.38,0,0,1,1.32,0l3.58.18c3,.17,7.21.43,11.82.76s8.79.64,11.8.9l3.58.33a7,7,0,0,1,1.31.18,7.54,7.54,0,0,1-1.32,0l-3.59-.18c-3-.17-7.2-.44-11.81-.76s-8.79-.65-11.81-.9L103,224A8,8,0,0,1,101.65,223.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.27,225.86a8.9,8.9,0,0,1,.72-1.22c.53-.84,1.23-1.92,2.07-3.24,1.74-2.73,4.14-6.52,6.67-10.77s4.72-8.16,6.29-11l1.86-3.37a8.3,8.3,0,0,1,.73-1.21,7.16,7.16,0,0,1-.57,1.3c-.39.82-1,2-1.73,3.43-1.49,2.89-3.64,6.83-6.18,11.09s-5,8-6.79,10.71c-.92,1.35-1.67,2.43-2.2,3.16A7.26,7.26,0,0,1,134.27,225.86Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.73,100.59H159.82a13.26,13.26,0,0,0-13.26,13.26V414a13.26,13.26,0,0,0,13.26,13.26H322.9s10.38,32.08-21.78,48.68H453.61s-36.31-12.45-27-48.68h158.1A13.25,13.25,0,0,0,598,414V113.85A13.25,13.25,0,0,0,584.73,100.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,394.92c5.78,8.26-3.27,17.31-11.53,11.53a3,3,0,0,1-.71-.72c-5.76-8.25,3.27-17.29,11.53-11.52A3,3,0,0,1,378,394.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.57,105.33H581a9.7,9.7,0,0,1,9.7,9.7V371.58a0,0,0,0,1,0,0H153.88a0,0,0,0,1,0,0V115A9.7,9.7,0,0,1,163.57,105.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,105.33H583.16a7.52,7.52,0,0,1,7.52,7.52v14.61a0,0,0,0,1,0,0H153.88a0,0,0,0,1,0,0v-13A9.15,9.15,0,0,1,163,105.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.79,
    cy: 116.86,
    r: 3.07,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.93,
    cy: 116.86,
    r: 3.07,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,116.86a3.07,3.07,0,1,1-3.07-3.07A3.07,3.07,0,0,1,188.7,116.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.76,426.52c0,.14-60.46.26-135,.26s-135-.12-135-.26,60.45-.25,135.05-.25S508.76,426.38,508.76,426.52Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-400--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.49,326.72v1.83h-10.7V313.81H350.2v1.83h-8.3v4.53h7.39V322H341.9v4.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.76,328.55,360.58,324c-.29,0-.61.05-.92.05H356v4.48H353.9V313.81h5.76c3.83,0,6.15,1.93,6.15,5.14a4.65,4.65,0,0,1-3.25,4.65l3.5,4.95Zm-.06-9.6c0-2.11-1.41-3.31-4.11-3.31H356v6.64h3.58C362.29,322.28,363.7,321.05,363.7,319Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.08,328.55,375.9,324c-.3,0-.61.05-.93.05h-3.64v4.48h-2.11V313.81H375c3.84,0,6.15,1.93,6.15,5.14a4.65,4.65,0,0,1-3.24,4.65l3.5,4.95ZM379,319c0-2.11-1.42-3.31-4.11-3.31h-3.58v6.64h3.58C377.6,322.28,379,321.05,379,319Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.33,321.18a7.85,7.85,0,1,1,7.86,7.54A7.49,7.49,0,0,1,383.33,321.18Zm13.57,0a5.73,5.73,0,1,0-5.71,5.67A5.53,5.53,0,0,0,396.9,321.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.09,328.55,408.91,324c-.3,0-.61.05-.93.05h-3.64v4.48h-2.11V313.81H408c3.84,0,6.15,1.93,6.15,5.14a4.65,4.65,0,0,1-3.24,4.65l3.5,4.95ZM412,319c0-2.11-1.41-3.31-4.11-3.31h-3.58v6.64h3.58C410.62,322.28,412,321.05,412,319Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.29,255.11q-5.44,34.2-23.71,49.69t-44.76,11.28q-26.62-4.23-39.3-24.65t-7.24-54.62l6.38-40.1q5.41-34.08,23.71-49.7t44.9-11.38q26.51,4.22,39.16,24.75T584.67,215Zm-22.17-49.26q3.43-21.53-2.15-33t-19.43-13.7q-13.86-2.2-22.66,7t-12.24,30.75l-7.75,48.73q-3.45,21.66,2.18,33.22t19.48,13.78q13.85,2.19,22.6-7t12.22-31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.47,247.5q-5.44,34.2-23.71,49.69T522,308.47q-26.61-4.23-39.29-24.65t-7.24-54.62l6.37-40.1q5.43-34.08,23.72-49.7T550.45,128q26.49,4.22,39.16,24.75t7.24,54.62ZM568.3,198.25q3.42-21.54-2.16-33t-19.43-13.7q-13.85-2.2-22.66,7t-12.24,30.74L504.06,238q-3.44,21.66,2.19,33.23T525.73,285q13.85,2.2,22.6-7t12.22-31Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M590.47,247.5q-5.44,34.2-23.71,49.69T522,308.47q-26.61-4.23-39.29-24.65t-7.24-54.62l6.37-40.1q5.43-34.08,23.72-49.7T550.45,128q26.49,4.22,39.16,24.75t7.24,54.62ZM568.3,198.25q3.42-21.54-2.16-33t-19.43-13.7q-13.85-2.2-22.66,7t-12.24,30.74L504.06,238q-3.44,21.66,2.19,33.23T525.73,285q13.85,2.2,22.6-7t12.22-31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M607.33,250.18q-5.45,34.21-23.71,49.7t-44.77,11.27q-26.61-4.23-39.29-24.65t-7.24-54.61l6.37-40.11q5.43-34.08,23.72-49.69t44.9-11.38q26.49,4.22,39.16,24.75t7.24,54.62Zm-22.17-49.25q3.42-21.54-2.16-33t-19.43-13.7q-13.85-2.2-22.66,7t-12.24,30.74l-7.75,48.73q-3.43,21.66,2.19,33.23t19.48,13.77q13.85,2.2,22.6-7t12.22-31Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.41,194.18c0,.12-4.14,1-9.3,2s-9.37,1.72-9.4,1.6,4.15-1,9.31-2S498.39,194.06,498.41,194.18Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.71,210.17c0,.12-4.14,1-9.3,2s-9.37,1.72-9.4,1.59,4.14-1,9.31-2S496.69,210.05,496.71,210.17Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495,226.15c0,.13-4.14,1-9.31,2s-9.37,1.72-9.39,1.6,4.14-1,9.31-2S495,226,495,226.15Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.31,242.14c0,.12-4.14,1-9.31,2s-9.37,1.72-9.39,1.6,4.14-1,9.31-2S493.28,242,493.31,242.14Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.61,258.12a12.89,12.89,0,0,1-2.47.65c-1.53.34-3.65.77-6,1.23s-4.48.85-6,1.11a12.7,12.7,0,0,1-2.52.32,14.21,14.21,0,0,1,2.46-.64c1.53-.34,3.65-.77,6-1.23s4.49-.85,6-1.11A14.5,14.5,0,0,1,491.61,258.12Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.68,273.36a10.92,10.92,0,0,1-2.14.58c-1.34.3-3.19.69-5.24,1.09s-3.91.73-5.26,1a11.27,11.27,0,0,1-2.2.27,10.38,10.38,0,0,1,2.14-.58c1.34-.3,3.19-.69,5.24-1.09s3.91-.73,5.26-.95A11.27,11.27,0,0,1,493.68,273.36Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.11,288.27a9.07,9.07,0,0,1-1.91.54c-1.19.27-2.84.62-4.66,1s-3.49.65-4.69.84a7.6,7.6,0,0,1-2,.22,8.76,8.76,0,0,1,1.91-.53c1.19-.27,2.84-.62,4.66-1s3.49-.65,4.69-.85A8.88,8.88,0,0,1,501.11,288.27Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.71,299.69a9.07,9.07,0,0,1-1.91.54c-1.19.27-2.83.61-4.66,1s-3.48.65-4.69.84a7.57,7.57,0,0,1-2,.22,8.32,8.32,0,0,1,1.9-.53c1.19-.27,2.84-.62,4.67-1s3.48-.65,4.68-.85A9,9,0,0,1,515.71,299.69Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.89,274.12c0,.12-5.37,1.64-12.08,3.39s-12.16,3.06-12.19,2.94,5.38-1.63,12.08-3.38S569.86,274,569.89,274.12Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.48,261.12c0,.12-4.44,1.39-10,2.84s-10.06,2.51-10.09,2.39,4.44-1.38,10-2.83S575.44,261,575.48,261.12Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.56,246.15c0,.12-4.43,1.39-10,2.83s-10.06,2.52-10.09,2.4,4.43-1.39,10-2.83S579.53,246,579.56,246.15Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.65,231.18c0,.12-4.43,1.39-10,2.83s-10.06,2.52-10.09,2.4,4.43-1.39,10-2.83S583.62,231.06,583.65,231.18Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.74,216.21c0,.12-4.44,1.38-10,2.83s-10,2.52-10.09,2.4,4.44-1.39,10-2.84S587.71,216.09,587.74,216.21Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587,202.13c0,.12-4.44,1.39-10,2.84s-10,2.52-10.08,2.39,4.43-1.38,10-2.83S587,202,587,202.13Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.47,187.53c0,.12-4.44,1.39-10,2.84s-10.06,2.52-10.09,2.4,4.44-1.39,10-2.84S589.43,187.41,589.47,187.53Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.27,173.53c0,.12-4.43,1.39-10,2.83s-10.06,2.52-10.09,2.4,4.43-1.39,10-2.83S590.24,173.41,590.27,173.53Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.83,161.75a87.25,87.25,0,0,1-12.2,3.18,44.38,44.38,0,0,1,6-1.81A43.91,43.91,0,0,1,578.83,161.75Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.84,154.7a44.82,44.82,0,0,1-6.05,1.81,44,44,0,0,1-6.15,1.37,43.82,43.82,0,0,1,6-1.81A45.69,45.69,0,0,1,572.84,154.7Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.4,175.13c0,.12-4.14,1-9.3,2s-9.37,1.72-9.4,1.6,4.15-1,9.31-2S502.38,175,502.4,175.13Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.6,156.22c0,.12-4.49,1.1-10.09,2.19s-10.15,1.87-10.17,1.75,4.49-1.1,10.09-2.19S510.58,156.1,510.6,156.22Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.61,138.84c0,.12-5.7,1.34-12.79,2.72S501,144,501,143.83s5.7-1.34,12.79-2.72S526.59,138.72,526.61,138.84Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47,247.62l22.38-1.74,1.84,23.71-22.37,1.74,3.06,39.39L245,313l-3.07-39.39-61.64,4.79.06-26,49.91-116.31,30.4-2.36Zm-77,6,47.54-3.7-5.58-71.85-.75-.19-2,5.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,236.14l22.37-1.74L280,258.11l-22.37,1.74,3.06,39.39-29.42,2.29-3.06-39.39-76,5.9-2.13-18,66.45-125.49,30.39-2.37Zm-77,6,47.54-3.69-5.59-71.85-.75-.19-2,5.42Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.77,236.14l22.37-1.74L280,258.11l-22.37,1.74,3.06,39.39-29.42,2.29-3.06-39.39-76,5.9-2.13-18,66.45-125.49,30.39-2.37Zm-77,6,47.54-3.69-5.59-71.85-.75-.19-2,5.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M236.29,237.57l22.37-1.74,1.84,23.71-22.37,1.74,3.06,39.39L211.77,303l-3.06-39.39-76,5.9-2.13-18L197,126l30.39-2.36Zm-77,6,47.54-3.69L201.28,168l-.75-.18-2,5.41Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,226.62a5.32,5.32,0,0,1-.94.54c-.62.33-1.52.78-2.64,1.33-2.23,1.1-5.34,2.57-8.79,4.14s-6.59,3-8.88,3.92c-1.14.49-2.07.86-2.72,1.12a5.21,5.21,0,0,1-1,.35,8.1,8.1,0,0,1,1-.48l2.68-1.22,8.84-4,8.83-4.05L187,227A7.18,7.18,0,0,1,188,226.62Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.62,207.46a7.7,7.7,0,0,1-1,.52c-.63.32-1.55.76-2.68,1.29-2.27,1.06-5.42,2.47-8.91,4s-6.68,2.84-9,3.76c-1.16.46-2.1.83-2.75,1.07a4.87,4.87,0,0,1-1,.33,9.1,9.1,0,0,1,1-.46l2.71-1.17,9-3.86,9-3.89,2.71-1.18A6.46,6.46,0,0,1,198.62,207.46Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.22,224.33a4.09,4.09,0,0,1-.68.46c-.46.28-1.12.67-1.94,1.14-1.65.95-3.95,2.22-6.52,3.57s-4.93,2.51-6.65,3.32l-2,1a4.38,4.38,0,0,1-.77.3,3.76,3.76,0,0,1,.71-.42l2-1.05,6.6-3.41,6.56-3.47,2-1.05A3.11,3.11,0,0,1,254.22,224.33Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.1,237.67a4.57,4.57,0,0,1-.69.46c-.45.28-1.12.67-1.94,1.14-1.65.95-4,2.22-6.52,3.57s-4.93,2.51-6.64,3.33c-.86.4-1.56.73-2.05.94a4.06,4.06,0,0,1-.77.3,3.76,3.76,0,0,1,.71-.42l2-1.05,6.59-3.41,6.56-3.47,2-1.05A3.64,3.64,0,0,1,278.1,237.67Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.13,249.6a4.57,4.57,0,0,1-.69.46c-.45.28-1.12.67-1.94,1.14-1.65,1-3.95,2.22-6.52,3.57s-4.93,2.51-6.64,3.32c-.86.41-1.56.73-2,1a4.06,4.06,0,0,1-.77.3,3.76,3.76,0,0,1,.71-.42l2-1.05,6.59-3.41,6.56-3.47,2-1.05A3.64,3.64,0,0,1,279.13,249.6Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.55,260.26a3.31,3.31,0,0,1-.66.46c-.44.27-1.08.66-1.88,1.13-1.59.94-3.81,2.21-6.3,3.55s-4.77,2.49-6.44,3.3c-.83.41-1.51.73-2,.94a3.24,3.24,0,0,1-.75.3,4,4,0,0,1,.69-.42c.52-.28,1.17-.62,1.93-1l6.38-3.39,6.35-3.45,1.93-1A3.64,3.64,0,0,1,257.55,260.26Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5,273.14a3.77,3.77,0,0,1-.66.46c-.44.28-1.08.66-1.88,1.13-1.59.94-3.82,2.21-6.3,3.55s-4.77,2.49-6.44,3.3c-.83.41-1.51.73-2,.94a3.24,3.24,0,0,1-.75.3,4,4,0,0,1,.69-.42l1.93-1,6.38-3.39,6.35-3.45,1.93-1A3.64,3.64,0,0,1,258.5,273.14Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.45,286a3.77,3.77,0,0,1-.66.46c-.44.28-1.08.66-1.88,1.13-1.59.94-3.82,2.21-6.3,3.55s-4.78,2.49-6.44,3.3c-.83.41-1.51.73-2,.94a3.24,3.24,0,0,1-.75.3,3.49,3.49,0,0,1,.69-.42l1.93-1,6.38-3.39,6.35-3.45,1.93-1A3.64,3.64,0,0,1,259.45,286Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.24,210.72a4,4,0,0,1-.69.46c-.45.28-1.11.67-1.94,1.14-1.65,1-3.94,2.22-6.51,3.57s-4.93,2.51-6.65,3.32l-2,.95a4.38,4.38,0,0,1-.77.3,3.76,3.76,0,0,1,.71-.42l2-1,6.59-3.41,6.56-3.47,2-1.05A3.73,3.73,0,0,1,253.24,210.72Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.26,197.11a4,4,0,0,1-.69.46c-.45.28-1.11.67-1.94,1.14-1.65.95-3.94,2.22-6.52,3.57s-4.92,2.51-6.64,3.32l-2,1a4,4,0,0,1-.78.3,4.15,4.15,0,0,1,.72-.42l2-1.05L243,202l6.56-3.47,2-1.05A3.73,3.73,0,0,1,252.26,197.11Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.77,181.23a3.25,3.25,0,0,1-.66.44c-.43.27-1.06.64-1.84,1.1-1.57.9-3.76,2.12-6.21,3.4s-4.69,2.39-6.33,3.16c-.82.39-1.49.69-1.95.9a3.5,3.5,0,0,1-.74.28,3.66,3.66,0,0,1,.68-.4l1.9-1,6.28-3.25,6.25-3.31c.75-.39,1.38-.73,1.9-1A3.69,3.69,0,0,1,250.77,181.23Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89,164.66a3,3,0,0,1-.65.44c-.43.27-1.06.64-1.85,1.1-1.57.9-3.75,2.12-6.2,3.4s-4.7,2.39-6.34,3.16c-.81.39-1.48.69-1.94.9a3.74,3.74,0,0,1-.74.28,4,4,0,0,1,.68-.41l1.9-1,6.28-3.25,6.24-3.31c.76-.39,1.39-.73,1.9-1A4.34,4.34,0,0,1,249.89,164.66Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79,147.67a3.65,3.65,0,0,1-.68.49l-1.94,1.2c-1.65,1-3.95,2.34-6.53,3.76s-4.94,2.66-6.67,3.53c-.86.44-1.56.78-2.05,1a4.66,4.66,0,0,1-.78.33,3.52,3.52,0,0,1,.71-.45l2-1.1,6.61-3.62,6.57-3.67,2-1.11A5,5,0,0,1,248.79,147.67Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.15,131.52a4.39,4.39,0,0,1-.72.45c-.47.27-1.15.65-2,1.11-1.71.92-4.09,2.15-6.76,3.46s-5.11,2.42-6.9,3.21c-.89.4-1.61.71-2.12.91a3.19,3.19,0,0,1-.8.29,4.44,4.44,0,0,1,.74-.41l2.07-1,6.84-3.3,6.8-3.37,2.07-1A3.88,3.88,0,0,1,248.15,131.52Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.47,189.85c.05.11-4.41,2.43-10,5.19s-10.12,4.91-10.17,4.8,4.4-2.44,10-5.2S203.41,189.73,203.47,189.85Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74,176a12.21,12.21,0,0,1-3.33,2.14,12.6,12.6,0,0,1-3.71,1.39,30.64,30.64,0,0,1,3.5-1.79A31.94,31.94,0,0,1,201.74,176Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.23,250.62C303.88,265.29,311,274.89,326.7,288c19,15.92,46.32,21.1,69.95,13.69s45.59-27.3,52.28-51.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.04,
    cy: 207.92,
    r: 87.03,
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.09,125.44c-2.84,2.28,1.26,6.94,4.05,9.28s6.11,5.12,5.73,8.75c-8.89,1.53-18.11,3.2-25.51,8.37-10.95,7.66-15.64,21.24-21.42,33.28-3.52,7.35-7.66,14.41-10.85,21.9s-5.44,15.59-4.91,23.72,4.18,16.33,10.85,21,16.51,5,22.72-.24q.3,3.42.62,6.86l-2.05,22.33,50.55,3.66,5.79-151.76V121.3S351.86,120.82,346.09,125.44Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.26,208.21c-3.6-2.05-7.8-2.47-11.93-2.38a45.66,45.66,0,0,0-12.18,2.22,37.91,37.91,0,0,0-9.6,4.15l.41,1.17a47,47,0,0,0,33.19-3.66c.29-.15,1.13-.5,1.07-.82S449.44,208.31,449.26,208.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.34,210.84c-.85,1.38-.4,3.3.32,4.75a11.59,11.59,0,0,0,3.18,3.62c3.82,3.15,8.42,5.63,13.36,5.88s10.21-2.14,12.38-6.59c.54-1.09,1.51-2.77,1.51-2.77a23.8,23.8,0,0,0-3.79-1.87c-4.45-1.72-8.63-3.68-13.33-4.53a23.76,23.76,0,0,0-13.63,1.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.39,157.61c-2.74-3-36.17-15.9-36.17-15.9l-31.73,2.23s-15.47,4-27.08,8.22a26.48,26.48,0,0,0-15.57,15l-17.5,43.66s2.58-1.46,10-1.36c7.66.11,20.72,6.25,20.72,6.25l-8.31,65.74c25.57,17.23,56.32,18.77,86.12,3.84l.17-9.38,3.21-62.84c3.32-4.51,21.37-10.37,33.94-4.2C450.22,208.89,438.06,163.84,432.39,157.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.38,173a2.44,2.44,0,0,1,.13-.79,13.74,13.74,0,0,1,.65-2.06,20.15,20.15,0,0,1,3.72-6.07,20.53,20.53,0,0,1,5.57-4.44,15.12,15.12,0,0,1,2-.89,2.51,2.51,0,0,1,.76-.23c0,.08-1,.49-2.57,1.4a22.36,22.36,0,0,0-9.16,10.35C413.73,171.9,413.45,173,413.38,173Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.46,212.39c-.12,0-.25-8.15-.29-18.21s0-18.21.16-18.22.25,8.16.29,18.22S413.59,212.39,413.46,212.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.16,177c.13,0-.7,8.56-1.84,19.08s-2.16,19-2.28,19,.7-8.56,1.84-19.08S339,177,339.16,177Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.52,143.45a2.63,2.63,0,0,1,0,.64,14.18,14.18,0,0,1-.07,1.81,20.24,20.24,0,0,1-1.76,6.44,20.87,20.87,0,0,1-6.14,7.73,20.6,20.6,0,0,1-23,1.12,20.8,20.8,0,0,1-6.86-7.11,20.25,20.25,0,0,1-2.37-6.24,15.23,15.23,0,0,1-.25-1.8,2.5,2.5,0,0,1,0-.63c.06,0,.1.87.45,2.4a21.39,21.39,0,0,0,2.47,6.11,20.84,20.84,0,0,0,6.81,6.91,20.34,20.34,0,0,0,22.55-1.09,20.86,20.86,0,0,0,6.1-7.53,21.49,21.49,0,0,0,1.88-6.33C400.5,144.33,400.46,143.45,400.52,143.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.57,201.1a4.05,4.05,0,0,1-.95-.33c-.59-.24-1.46-.59-2.53-1a72.68,72.68,0,0,0-17.35-4.31c-1.14-.14-2.06-.24-2.7-.3a4.79,4.79,0,0,1-1-.15,4.23,4.23,0,0,1,1,0c.64,0,1.57.06,2.72.16a59.76,59.76,0,0,1,17.44,4.32c1.06.45,1.91.84,2.48,1.13A4.38,4.38,0,0,1,335.57,201.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.94,197.6c0,.13-17-.3-37.9-1s-37.89-1.29-37.89-1.42,17,.31,37.91,1S412.94,197.48,412.94,197.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,185.92a6.13,6.13,0,0,1-1.19,0c-.77,0-1.87-.07-3.23-.06a50.86,50.86,0,0,0-20.62,4.48c-1.24.56-2.24,1-2.91,1.39a5.73,5.73,0,0,1-1.08.5,6.15,6.15,0,0,1,1-.65c.65-.4,1.63-.93,2.86-1.53a46.44,46.44,0,0,1,10.12-3.47,46,46,0,0,1,10.64-1,32.07,32.07,0,0,1,3.24.2A6.65,6.65,0,0,1,443,185.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,173.66c-.05.06-.89-.6-2.35-1.51a29.08,29.08,0,0,0-6-2.82,29.54,29.54,0,0,0-6.53-1.35c-1.71-.15-2.78-.12-2.78-.2a2.78,2.78,0,0,1,.75-.1,16.77,16.77,0,0,1,2.05,0,24.71,24.71,0,0,1,6.65,1.23,24.36,24.36,0,0,1,6.06,3,15.45,15.45,0,0,1,1.64,1.24A2.89,2.89,0,0,1,339,173.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.67,172.17a2.49,2.49,0,0,1-.65,0l-1.85-.12-6.81-.49c-5.74-.41-13.68-.9-22.46-1.25s-16.74-.48-22.5-.52l-6.82-.05-1.86,0a4,4,0,0,1-.64,0,3.2,3.2,0,0,1,.64,0l1.86-.06c1.61-.05,3.94-.09,6.82-.1,5.76,0,13.73,0,22.52.39s16.73.89,22.47,1.38c2.87.24,5.19.46,6.79.63l1.85.21A4.22,4.22,0,0,1,407.67,172.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.35,151.4a64.89,64.89,0,0,1-7.52-.27,63.53,63.53,0,0,1-7.49-.72,64.89,64.89,0,0,1,7.52.27A60.8,60.8,0,0,1,359.35,151.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.06,150.49c0,.12-4.36.22-9.72.22s-9.72-.1-9.72-.22,4.35-.23,9.72-.23S419.06,150.36,419.06,150.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.05,229.63s-.07,0-.2,0l-.61,0-2.32,0c-2,0-4.94,0-8.55-.07-7.22-.12-17.2-.46-28.19-1.16s-20.94-1.63-28.12-2.43c-3.58-.4-6.48-.75-8.49-1l-2.3-.32-.6-.09-.2-.05h.21l.6.05,2.31.23,8.51.87c7.18.72,17.11,1.6,28.11,2.3s21,1.09,28.16,1.29l8.55.21,2.32.07.61,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.64,257.55l-.21.06-.63.14-2.42.48c-1.06.21-2.35.46-3.86.68s-3.22.54-5.13.76-4,.52-6.24.72-4.66.38-7.19.55c-5.08.27-10.67.37-16.53.17S361,260.39,356,259.76c-2.52-.35-4.91-.66-7.14-1.07s-4.29-.77-6.17-1.16-3.58-.78-5.06-1.12-2.76-.67-3.8-1l-2.38-.66-.62-.18a.61.61,0,0,1-.21-.08l.22,0,.63.14,2.4.57c1,.26,2.32.57,3.81.88s3.18.72,5.07,1.06,3.95.76,6.18,1.1,4.61.69,7.12,1c5,.6,10.59,1.09,16.44,1.31s11.43.11,16.49-.13c2.53-.16,4.94-.28,7.18-.52s4.34-.42,6.24-.65,3.62-.49,5.13-.7,2.81-.42,3.87-.6l2.43-.4.64-.1C414.57,257.54,414.64,257.54,414.64,257.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,281.4l-.21.08-.63.19-2.44.71c-.53.14-1.12.32-1.77.48l-2.13.48-2.45.54c-.87.18-1.8.31-2.78.48s-2,.34-3.05.5l-3.34.4-1.76.2-1.82.14-3.8.29a166.77,166.77,0,0,1-17-.1c-6-.4-11.71-1.13-16.86-2l-3.74-.73-1.79-.35-1.72-.41-3.27-.77-3-.83a93.5,93.5,0,0,1-12.05-4.18.63.63,0,0,1,.22.06l.63.21,2.39.85c.52.18,1.09.4,1.72.61l2.08.65,2.39.75c.85.26,1.76.48,2.71.75l3,.79,3.27.75,1.72.39,1.79.34,3.74.71c5.13.84,10.81,1.55,16.81,1.95a169.13,169.13,0,0,0,16.92.13l3.79-.26,1.82-.13,1.75-.2,3.33-.37c1.06-.14,2.08-.32,3.05-.46s1.9-.29,2.77-.45l2.46-.51,2.13-.43c.65-.15,1.24-.32,1.78-.45l2.46-.63.64-.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.82,248a86.19,86.19,0,0,0,39-18.75c2-1.67,4.09-3.53,6.68-3.62,2.91-.1,5.33,2.08,7.55,4a66.79,66.79,0,0,0,30.79,14.79c1.64-2.56.93-6.08-.88-8.52s-4.52-4-7.14-5.56L382.25,216c-1.86-1.09-3.92-2.21-6.05-1.87a9.44,9.44,0,0,0-3.8,1.89l-38.35,27c-1.68,1.19-3.57,3.24-2.47,5",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.76,210.35s-5.75,17.1-6.57,20.05c-1.58,5.73-.1,20.66,13.84,20.66,16.9,0,78.57-39.79,78.57-39.79L380,203.68,330,220l1.92-5.64S318.06,207.19,306.76,210.35Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.26,204.26s16.49-21.44,16.49-21.72,9.79-8.66,9.79-8.66,2.16.1,2,1.51-3.67,6.39-3.67,6.39a13.32,13.32,0,0,1-1.69,3.13c-1,1.43-5.83,10-5.83,10s4.61-4.42,5.45-4a1.77,1.77,0,0,1,1,2.44c-.47,1.41-4.8,5.74-4.8,5.74s-2.54,8.94-5.36,11.48l-7.06,4.7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.61,198.59a3.56,3.56,0,0,1-.72,2.65,25.58,25.58,0,0,1-1.83,2.38,9.78,9.78,0,0,0-1.67,3.14c-.41,1.21-.72,2.42-1.15,3.48a8.45,8.45,0,0,1-1.57,2.59A4.74,4.74,0,0,1,387,214a1.76,1.76,0,0,1-.73.17,5.94,5.94,0,0,0,2.16-1.58,8.78,8.78,0,0,0,1.43-2.52c.39-1,.68-2.24,1.11-3.47a9.63,9.63,0,0,1,1.77-3.26c.72-.87,1.42-1.59,1.88-2.29A6,6,0,0,0,395.61,198.59Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.86,182.31s-.17-.19-.53-.43a2.54,2.54,0,0,0-1.73-.35,3.91,3.91,0,0,0-2.29,1.32c-.71.75-1.37,1.72-2.13,2.68-1.49,1.94-2.86,3.68-3.87,4.93a14.26,14.26,0,0,1-1.71,2,14.54,14.54,0,0,1,1.45-2.15c.95-1.3,2.28-3.07,3.77-5,.76-1,1.43-1.92,2.19-2.7a4.13,4.13,0,0,1,2.55-1.34,2.54,2.54,0,0,1,1.88.52C404.8,182.05,404.88,182.31,404.86,182.31Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,203.62c-.13-.05.51-2,1-4.38s.6-4.43.73-4.43a12.69,12.69,0,0,1-.29,4.52A13.27,13.27,0,0,1,395.74,203.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.68,206.77s6.06,17.33,6.88,20.29c1.27,4.56.1,20.66-13.84,20.66-16.9,0-78.56-39.8-78.56-39.8L369.8,200l50.95,16.63-2-5.81A40.11,40.11,0,0,1,443.68,206.77Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.49,200.92S354,179.47,354,179.19s-9.78-8.65-9.78-8.65-2.16.09-2,1.5,3.66,6.4,3.66,6.4a13.55,13.55,0,0,0,1.7,3.12c1,1.44,5.83,9.95,5.83,9.95s-4.61-4.42-5.46-3.95a1.78,1.78,0,0,0-1,2.45c.47,1.41,4.8,5.74,4.8,5.74s2.54,8.93,5.36,11.47l7.05,4.7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.15,195.24a5.9,5.9,0,0,0,1,2.49c.47.69,1.16,1.41,1.89,2.29a9.58,9.58,0,0,1,1.77,3.25c.42,1.24.72,2.44,1.11,3.47a8.85,8.85,0,0,0,1.43,2.53,5.83,5.83,0,0,0,2.16,1.57,1.56,1.56,0,0,1-.73-.17,4.49,4.49,0,0,1-1.67-1.19,8.66,8.66,0,0,1-1.58-2.59c-.42-1.06-.73-2.26-1.15-3.47a9.66,9.66,0,0,0-1.66-3.14,24,24,0,0,1-1.83-2.38A3.58,3.58,0,0,1,355.15,195.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,179s.06-.27.42-.58a2.62,2.62,0,0,1,1.87-.52,4.05,4.05,0,0,1,2.55,1.35,31.05,31.05,0,0,1,2.19,2.69c1.5,1.94,2.83,3.71,3.77,5a14.55,14.55,0,0,1,1.46,2.16,16,16,0,0,1-1.71-2c-1-1.25-2.38-3-3.87-4.93-.76-1-1.43-1.93-2.13-2.68a3.94,3.94,0,0,0-2.29-1.32,2.64,2.64,0,0,0-1.74.34C346.06,178.77,345.93,179,345.9,179Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,200.27a17.74,17.74,0,0,1-1.71-8.8c.13,0,.25,2,.73,4.43S355.15,200.23,355,200.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.89,224.25c-.07.1-6.34-3.62-14-8.32s-13.84-8.6-13.77-8.71,6.33,3.62,14,8.32S385,224.14,384.89,224.25Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.79,217.15a3.11,3.11,0,0,1-.54-.13l-1.53-.45-5.6-1.73c-4.73-1.49-11.25-3.57-18.43-5.92s-13.67-4.52-18.36-6.14c-2.34-.81-4.23-1.48-5.53-2l-1.49-.57a2.05,2.05,0,0,1-.51-.23,3.44,3.44,0,0,1,.54.14l1.52.49,5.58,1.83,18.39,6,18.38,6,5.56,1.87,1.51.53A2.08,2.08,0,0,1,421.79,217.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53,68.17h0a24,24,0,0,0-24,23.21c-.39,11.56-.66,24.33-.29,30.5.76,12.81,13.67,14.19,13.67,14.19v7.84a16.54,16.54,0,0,0,16.54,16.57h0A16.55,16.55,0,0,0,397,144.25l1-51.42A23.74,23.74,0,0,0,374.53,68.17Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.9,136.1a29.81,29.81,0,0,0,16.48-5.53s-3.64,9.54-16.48,9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.44,98.78c.23.24,1.61-.8,3.58-.81s3.42,1,3.63.73-.13-.54-.76-1a5,5,0,0,0-2.91-.88,4.84,4.84,0,0,0-2.85.94C354.53,98.24,354.32,98.67,354.44,98.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,98.41c.23.23,1.59-.83,3.56-.87s3.44.9,3.65.65-.14-.53-.78-1a5,5,0,0,0-2.93-.83,4.84,4.84,0,0,0-2.83,1C374,97.87,373.83,98.31,374,98.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,112.06a13.47,13.47,0,0,0-3.23-.42c-.51,0-1-.11-1.09-.45a2.56,2.56,0,0,1,.27-1.5c.41-1.24.85-2.54,1.3-3.9,1.81-5.55,3.09-10.11,2.87-10.18s-1.87,4.37-3.68,9.92c-.43,1.37-.85,2.67-1.24,3.92a3,3,0,0,0-.17,2,1.27,1.27,0,0,0,.86.69,3,3,0,0,0,.86.08A13.25,13.25,0,0,0,366.52,112.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.68,93.87c.31.48,2.18-.2,4.49-.44s4.29,0,4.48-.57c.08-.25-.35-.68-1.2-1a7.87,7.87,0,0,0-6.83.77C372.87,93.13,372.55,93.64,372.68,93.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.79,93.8c.25.53,1.79.44,3.5.87s3.08,1.1,3.53.74c.21-.19.09-.68-.44-1.25a5.55,5.55,0,0,0-5.66-1.3C354,93.15,353.68,93.55,353.79,93.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1,116.29c-.08.11-.53-.15-1.3-.36a5.69,5.69,0,0,0-3,0,5.54,5.54,0,0,0-2.51,1.63c-.54.59-.78,1.06-.91,1s-.07-.61.39-1.39a4.92,4.92,0,0,1,2.78-2.11,4.87,4.87,0,0,1,3.48.29C373.84,115.74,374.18,116.21,374.1,116.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.24,100.53a1.8,1.8,0,0,0,1.82,1.74,1.73,1.73,0,0,0,1.79-1.71A1.82,1.82,0,0,0,358,98.81,1.73,1.73,0,0,0,356.24,100.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.74,100a1.81,1.81,0,0,0,1.83,1.74,1.73,1.73,0,0,0,1.79-1.72,1.81,1.81,0,0,0-1.83-1.74A1.73,1.73,0,0,0,375.74,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.26,92.25a3.17,3.17,0,0,0,.8-2.55c-.26-1-1.39-1.64-1.78-2.64s0-2.11,0-3.17a5.81,5.81,0,0,0-2.08-3.79c-.11-.11-.23-.21-.35-.31a29.72,29.72,0,0,0-3.4-5.7l3.32,3.08c1.16-3.23-3.56-8.94-7.45-10.62a12,12,0,0,0-8.33,0s-9.8-7.38-19.4-5c-5.88,1.48-11.79,4-15.77,9.89a6.78,6.78,0,0,0-3.38,4.15c-.72,2.2-.87,4.6-2,6.64-.79,1.48-2.09,3-1.69,4.59.34,1.33,1.75,2.16,2.2,3.46s-.16,2.72-.14,4.1a4.67,4.67,0,0,0,3.79,4.42c.58-3.47,1-7,1.25-10.5,1.69,1.1,5.25,2.17,12.15-.17l8.89-5s-4.39,3.8-2.25,4.44c1.82.55,11.35-4.63,14.2-6.22a4.8,4.8,0,0,1,2.79-.62c1.3.14,2.82.86,3.14,3.4.27,2.17-1,22.55.88,22.56,1.06,0,5.14-1.77,5.83-2.24v9.88a2.37,2.37,0,0,0,.88-.87l4.26-6.08a22.89,22.89,0,0,0,2.59-4.36,7.68,7.68,0,0,0,.48-5c-.32-1.13-1-2.24-.81-3.41A5.85,5.85,0,0,1,406.26,92.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.26,60.42c.14-.26.79-.27,1.69.14a7.59,7.59,0,0,1,4.12,6.11c0,1-.21,1.59-.51,1.62-.64,0-1.25-2-2.63-4S382,61,382.26,60.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.06,74.78a4.1,4.1,0,0,0,1,1.27,4.68,4.68,0,0,0,4.24.59,11.72,11.72,0,0,0,2.77-1.38c.95-.6,1.93-1.32,3.09-1.91a6.76,6.76,0,0,1,4-.89,13.37,13.37,0,0,1,4.1,1.44,11.5,11.5,0,0,0,4,1.35,5.83,5.83,0,0,0,3.64-1C379,72.87,380.38,71,382,69.85a7.48,7.48,0,0,1,4.21-1.75,4.33,4.33,0,0,1,1.25.14c.27.1.41.15.4.17a6.43,6.43,0,0,0-1.64-.14,7.63,7.63,0,0,0-4,1.84c-1.52,1.14-2.91,3-5.08,4.48a6.22,6.22,0,0,1-3.91,1.1,11.88,11.88,0,0,1-4.12-1.38,12.86,12.86,0,0,0-3.95-1.41,6.46,6.46,0,0,0-3.73.82c-1.11.56-2.1,1.26-3.07,1.86a11.35,11.35,0,0,1-2.88,1.36,4.8,4.8,0,0,1-4.44-.75,2.82,2.82,0,0,1-.77-1A1.09,1.09,0,0,1,350.06,74.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.89,84.3s0,.09-.1.23a2.52,2.52,0,0,1-.45.56,3.77,3.77,0,0,1-2.45.9,5.62,5.62,0,0,1-3.62-1.37A22.24,22.24,0,0,1,395,81.21,36.4,36.4,0,0,1,390.42,74c-.47-1-.8-1.81-1-2.38a3.76,3.76,0,0,1-.28-.91c.07,0,.58,1.22,1.58,3.15a42.65,42.65,0,0,0,4.64,7.07,24.66,24.66,0,0,0,3.17,3.37,5.45,5.45,0,0,0,3.36,1.37,3.79,3.79,0,0,0,2.35-.72A7.25,7.25,0,0,0,404.89,84.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,96s-.2.14-.61.27a6.49,6.49,0,0,1-1.79.28A10.06,10.06,0,0,1,397,94.78a19.86,19.86,0,0,1-4.3-4.08,12.94,12.94,0,0,1-1.43-2,13.45,13.45,0,0,1,1.68,1.77,23,23,0,0,0,4.3,3.92,10.61,10.61,0,0,0,5.39,1.82A15.31,15.31,0,0,0,405,96Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,99.05c.22-.1,8.68-3,8.82,5.75s-8.7,7.1-8.72,6.85S394,99.05,394,99.05Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.69,108.29s.15.1.41.22a1.52,1.52,0,0,0,1.14,0c.92-.35,1.68-1.84,1.7-3.42a5.09,5.09,0,0,0-.46-2.18,1.78,1.78,0,0,0-1.17-1.16.77.77,0,0,0-.89.44c-.12.24-.06.42-.11.43s-.19-.14-.12-.5a.92.92,0,0,1,.34-.56,1.15,1.15,0,0,1,.84-.23,2.15,2.15,0,0,1,1.62,1.33,5.32,5.32,0,0,1,.56,2.44c0,1.77-.91,3.44-2.17,3.82a1.65,1.65,0,0,1-1.4-.21C396.7,108.5,396.66,108.3,396.69,108.29Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.26,349.29c0,2.48-1.88,3.91-5.54,3.91h-6.91V338.72h6.49c3.33,0,5.19,1.41,5.19,3.75a3.42,3.42,0,0,1-1.94,3.22A3.51,3.51,0,0,1,311.26,349.29Zm-10.38-8.89V345h4.24c2.11,0,3.3-.79,3.3-2.32s-1.19-2.31-3.3-2.31Zm8.29,8.72c0-1.67-1.24-2.41-3.54-2.41h-4.75v4.81h4.75C307.93,351.52,309.17,350.8,309.17,349.12Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.68,349.58H316l-1.59,3.62h-2.13l6.55-14.48h2.05l6.57,14.48h-2.17Zm-.72-1.65-3.13-7.1-3.12,7.1Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.59,338.72h6.1c4.65,0,7.82,2.94,7.82,7.24s-3.17,7.24-7.82,7.24h-6.1Zm6,12.68c3.57,0,5.87-2.19,5.87-5.44s-2.3-5.44-5.87-5.44h-3.91V351.4Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,353.2l-3.12-4.45c-.29,0-.6,0-.91,0h-3.58v4.41h-2.06V338.72h5.64c3.76,0,6,1.91,6,5a4.57,4.57,0,0,1-3.19,4.57l3.44,4.86Zm-.06-9.43c0-2.07-1.39-3.25-4-3.25h-3.52V347h3.52C360.45,347,361.84,345.84,361.84,343.77Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.76,351.4v1.8H367.25V338.72h10.22v1.8h-8.15V345h7.26v1.76h-7.26v4.67Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,354.52a4.65,4.65,0,0,1-3.64,1.7c-1.82,0-3.24-.79-5.27-2.88a7.41,7.41,0,1,1,8.21-7.38,7.2,7.2,0,0,1-5.69,7.18,3.75,3.75,0,0,0,2.77,1.44,3.42,3.42,0,0,0,2.65-1.24Zm-8.37-3a5.56,5.56,0,1,0-5.65-5.56A5.44,5.44,0,0,0,387.58,351.52Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.28,347v-8.23h2.07v8.15c0,3.21,1.47,4.65,4.07,4.65s4.1-1.44,4.1-4.65v-8.15h2V347c0,4.2-2.29,6.41-6.12,6.41S398.28,351.15,398.28,347Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.26,351.4v1.8h-10.5V338.72H425v1.8h-8.14V345h7.25v1.76h-7.25v4.67Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.28,351.54l.77-1.61a7.44,7.44,0,0,0,4.78,1.68c2.5,0,3.57-1,3.57-2.24,0-3.53-8.76-1.3-8.76-6.68,0-2.23,1.73-4.13,5.54-4.13a8.5,8.5,0,0,1,4.65,1.28l-.68,1.65a7.52,7.52,0,0,0-4-1.17c-2.46,0-3.52,1-3.52,2.29,0,3.54,8.77,1.32,8.77,6.64,0,2.21-1.78,4.11-5.6,4.11A8.58,8.58,0,0,1,427.28,351.54Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.11,340.52h-5v-1.8h12v1.8h-5V353.2h-2.05Z",
    style: {
      fill: "#F16920"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.51,111.94l-9.74-17.17a46,46,0,1,0-11,12.25l0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.51,111.94l-20.8-4.77a.12.12,0,0,1-.1-.15.08.08,0,0,1,0,0l0,0,.18.18a47.66,47.66,0,0,1-9.45,5.69,46.24,46.24,0,0,1-12.59,3.59,41.33,41.33,0,0,1-7.27.37c-1.25-.07-2.52-.11-3.81-.21l-3.88-.59a46.36,46.36,0,0,1-28.69-18.42,45.78,45.78,0,0,1-7.76-17.74,46.93,46.93,0,0,1,.54-20.43,45.43,45.43,0,0,1,9.84-18.88l1.88-2.06c.62-.7,1.35-1.27,2-1.9a27.36,27.36,0,0,1,2.08-1.82l2.2-1.65a20.58,20.58,0,0,1,2.29-1.51l2.32-1.41L265,29a20.89,20.89,0,0,1,2.47-1.1A46.82,46.82,0,0,1,288,24.72a45.37,45.37,0,0,1,18.89,5.58,46.53,46.53,0,0,1,21.79,26.82,49.36,49.36,0,0,1,2,14.93A45.54,45.54,0,0,1,328.48,85a47,47,0,0,1-4.61,9.88v-.12c6.18,11,9.21,16.46,9.64,17.23l-9.85-17.11a.15.15,0,0,1,0-.13,46.4,46.4,0,0,0,4.53-9.84A45.85,45.85,0,0,0,330.37,72a49.19,49.19,0,0,0-2-14.8A46.22,46.22,0,0,0,306.7,30.71a44.93,44.93,0,0,0-18.7-5.5,46.45,46.45,0,0,0-20.36,3.14,21,21,0,0,0-2.43,1.09l-2.41,1.17L260.5,32a18.76,18.76,0,0,0-2.26,1.49l-2.18,1.63a26.8,26.8,0,0,0-2.06,1.8c-.66.62-1.38,1.19-2,1.88l-1.86,2a44.78,44.78,0,0,0-9.73,18.67,46.35,46.35,0,0,0-.56,20.2,45.55,45.55,0,0,0,7.66,17.56,45.89,45.89,0,0,0,28.39,18.3l3.84.6c1.28.11,2.54.14,3.78.21a40.69,40.69,0,0,0,7.21-.34,45.6,45.6,0,0,0,21.93-9.13.13.13,0,0,1,.18,0,.11.11,0,0,1,0,.15v0l-.08-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.07,
    y: 53.31,
    width: 7.9,
    height: 35.42,
    transform: "translate(136.63 -181.94) rotate(45.73)",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.07,
    y: 53.31,
    width: 7.9,
    height: 35.42,
    transform: "translate(31.06 218.41) rotate(-44.27)",
    style: {
      fill: "#F16920"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.66,476.3c0,.14-151,.26-337.13.26s-337.16-.12-337.16-.26S190.29,476,376.53,476,713.66,476.15,713.66,476.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.13,416.92V405.71c-14,0-11.64-8.64-11.64-37.41,0-19.75.62-30.23-7.28-30.23-7.3,0-9,5.12-9,27.59C59.16,407.29,64.72,416.92,87.13,416.92Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.72,451.6V440.4c14,0,11.64-8.65,11.64-37.41,0-19.76-.62-30.24,7.28-30.24,7.3,0,9,5.12,9,27.6C129.69,442,124.13,451.6,101.72,451.6Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "106.61 439.87 108.8 451.18 104.99 451.52 104.42 440.26 106.61 439.87"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.81,302.58c-11.07,0-10.25,14.48-10.25,32.22V475.87h20.5V334.8C105.06,317.06,105.88,302.58,94.81,302.58Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.81,302.58c-11.07,0-10.25,14.48-10.25,32.22V475.87h20.5V334.8C105.06,317.06,105.88,302.58,94.81,302.58Z",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.85,476.31a3.82,3.82,0,0,1,0-.45c0-.32,0-.76,0-1.32v-5.09c0-4.45.07-10.83.12-18.71.15-15.83.35-37.64.58-61.74s.55-45.92.73-61.74c0-3.95.1-7.53.33-10.66a51.48,51.48,0,0,1,1.15-8,32.27,32.27,0,0,1,1.51-4.87c.21-.54.41-.94.53-1.21s.2-.41.2-.41l-.15.43c-.11.28-.29.68-.49,1.23a38.43,38.43,0,0,0-1.41,4.87,55.33,55.33,0,0,0-1,8c-.2,3.12-.22,6.69-.25,10.64-.15,15.83-.35,37.64-.58,61.75s-.55,45.91-.73,61.73c-.12,7.88-.22,14.27-.29,18.71,0,2.19-.07,3.9-.1,5.09,0,.56,0,1,0,1.32S88.85,476.31,88.85,476.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1,476.11s0-.16,0-.45,0-.76,0-1.32c0-1.18,0-2.89,0-5.07,0-4.42,0-10.78.09-18.63.12-15.75.29-37.48.47-61.47s.47-45.73.63-61.48c0-3.93.08-7.49,0-10.61a68.93,68.93,0,0,0-.74-8,47.15,47.15,0,0,0-1-4.95c-.15-.54-.26-1-.35-1.27s-.11-.43-.11-.43a34.62,34.62,0,0,1,1.7,6.62,67,67,0,0,1,.83,8c.16,3.13.15,6.69.13,10.62-.12,15.76-.29,37.48-.48,61.48s-.46,45.72-.62,61.47c-.11,7.85-.19,14.21-.25,18.63,0,2.18-.08,3.89-.1,5.07,0,.56,0,1,0,1.32S98.1,476.11,98.1,476.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.27,451.42a32.09,32.09,0,0,1-.46-5.71,30.53,30.53,0,0,1,.07-5.73,31.58,31.58,0,0,1,.45,5.71A32.19,32.19,0,0,1,105.27,451.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19,372.88a4.29,4.29,0,0,1,.06.81l0,2.31c0,2.07.06,5,.11,8.52,0,7.25.09,17.16.15,28.12,0,5.48,0,10.77-1,15.47a25.2,25.2,0,0,1-5.21,11.48,17.45,17.45,0,0,1-6.77,5.15,11,11,0,0,1-3,.82,25.9,25.9,0,0,0,2.94-1,17.63,17.63,0,0,0,6.56-5.19,25.18,25.18,0,0,0,5-11.34c.93-4.65,1-9.89.93-15.38V384.53c0-3.56,0-6.46.06-8.53,0-1,0-1.74,0-2.31A5.13,5.13,0,0,1,121.19,372.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.54,405.29a79.76,79.76,0,0,1,0,12.87,79.76,79.76,0,0,1,0-12.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,338.08a7.33,7.33,0,0,1,0,.82l0,2.36c-.06,2.09-.14,5-.25,8.66-.21,7.31-.63,17.41-.49,28.57.13,5.57.09,10.92,1.24,15.61a26.45,26.45,0,0,0,5.4,11.41,16.18,16.18,0,0,0,7,4.81,19.66,19.66,0,0,0,3.09.66,9.68,9.68,0,0,1-3.15-.47,15.91,15.91,0,0,1-7.2-4.76,26.42,26.42,0,0,1-5.59-11.54c-1.2-4.76-1.17-10.15-1.3-15.71-.14-11.18.34-21.29.65-28.6.17-3.61.31-6.55.41-8.65l.13-2.35A4.43,4.43,0,0,1,67.67,338.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.77,416.69l.41-11.51,2.39.4,0,11.29S82.18,416.73,81.77,416.69Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M61.39,376.15a6.2,6.2,0,0,1-2.43.62,6.28,6.28,0,0,1-2.52.12,6.19,6.19,0,0,1,2.44-.63A5.92,5.92,0,0,1,61.39,376.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.15,365a6.25,6.25,0,0,1-2.53-.24,6.39,6.39,0,0,1-2.43-.75,6.46,6.46,0,0,1,2.53.24A6.39,6.39,0,0,1,61.15,365Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.69,347.17a5,5,0,0,1,2.5,1.08c1.27.84,2.06,1.8,2,1.89a12.06,12.06,0,0,1-2.25-1.46A12.33,12.33,0,0,1,56.69,347.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.87,335.78a7,7,0,0,1,1.23,2.38,6.88,6.88,0,0,1,.75,2.57,13.89,13.89,0,0,1-2-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,336.54a11.11,11.11,0,0,1-1.38,3.1,11,11,0,0,1-1.84,2.84,22.9,22.9,0,0,1,3.22-5.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.49,349.9a5.65,5.65,0,0,1-2.16.87,5.29,5.29,0,0,1-2.3.36,5.65,5.65,0,0,1,2.16-.87A5.29,5.29,0,0,1,77.49,349.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.79,364.26c-.1.1-.74-.44-1.43-1.19s-1.15-1.44-1-1.54.75.44,1.43,1.19S71.9,364.16,71.79,364.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.47,378.65c-.1.11-1-.59-2-1.55s-1.77-1.82-1.67-1.92,1,.58,2,1.54S76.57,378.55,76.47,378.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.63,384.81c.1.11-.71,1-1.8,2.05a7.42,7.42,0,0,1-2.16,1.67c-.1-.11.71-1,1.8-2A7.42,7.42,0,0,1,62.63,384.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.37,397.44c-.14,0,0-.91.37-1.94s.73-1.82.86-1.77,0,.91-.37,1.94S64.5,397.49,64.37,397.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.64,412.07A10.71,10.71,0,0,1,66.75,409a10.53,10.53,0,0,1,1.59-2.86,10.6,10.6,0,0,1-1.11,3.08A10.69,10.69,0,0,1,65.64,412.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.08,418.75a8.12,8.12,0,0,1,.24-2.89,7.92,7.92,0,0,1,.77-2.8,8.28,8.28,0,0,1-.25,2.89A8.4,8.4,0,0,1,74.08,418.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,396.64a5.76,5.76,0,0,1-2.4-.27,5.66,5.66,0,0,1-2.29-.77,5.76,5.76,0,0,1,2.4.27A5.59,5.59,0,0,1,78.49,396.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.49,388a4.18,4.18,0,0,1-2-.11c-1.09-.21-2-.49-1.93-.63s.93-.09,2,.12S77.52,387.89,77.49,388Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.64,338.69c.36,0,.57,4.45.28,11.6-.13,3.57-.38,7.81-.66,12.52s-.6,9.86-.71,15.26A59.49,59.49,0,0,0,67.82,393a40.94,40.94,0,0,0,1.85,6.23,23,23,0,0,0,2.65,4.89,16.26,16.26,0,0,0,6.09,5.17c1.74.84,2.83,1.11,2.79,1.32s-1.17.22-3.16-.37a15.34,15.34,0,0,1-7.17-5,23.17,23.17,0,0,1-3.19-5.17,41.55,41.55,0,0,1-2.2-6.52A56.54,56.54,0,0,1,63.94,378c.12-5.5.52-10.68.93-15.39s.85-8.93,1.21-12.47C66.84,343.07,67.28,338.68,67.64,338.69Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M115.49,424.18a9.91,9.91,0,0,1-4.51,0,5,5,0,0,1,2.26-.26A5,5,0,0,1,115.49,424.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.36,413.29a4.72,4.72,0,0,1-2.18-.21c-1.17-.25-2.1-.58-2.06-.72a4.84,4.84,0,0,1,2.17.21A4.79,4.79,0,0,1,115.36,413.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.89,401.12a6.8,6.8,0,0,1-2.61,0,6.75,6.75,0,0,1-2.56-.47,6.64,6.64,0,0,1,2.6-.05A6.56,6.56,0,0,1,115.89,401.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.17,390.34a4.49,4.49,0,0,1-2-.63c-1.07-.47-1.88-1-1.82-1.1a4.49,4.49,0,0,1,2,.63C113.41,389.71,114.23,390.21,114.17,390.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.23,381.18a4.73,4.73,0,0,1-2.12-1.28c-1-.9-1.7-1.81-1.6-1.9s.92.63,1.93,1.5S115.31,381.06,115.23,381.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.4,374.42c-.13.06-.65-.75-1.16-1.81s-.83-2-.7-2,.65.75,1.17,1.81S118.53,374.36,118.4,374.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,372c.11.1-.39.88-1,1.85s-1.06,1.77-1.19,1.71.14-1,.75-2S127.34,371.94,127.45,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,384a7.94,7.94,0,0,1-4.91.4,8,8,0,0,1,2.45-.33A7.67,7.67,0,0,1,131.68,384Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,392.59c.07.13-.86.76-2.07,1.42a6.12,6.12,0,0,1-2.32.95,6.43,6.43,0,0,1,2.07-1.41A6.53,6.53,0,0,1,131.55,392.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8,406.69c-.06.13-.91-.15-1.9-.62s-1.75-1-1.69-1.1.92.15,1.91.63S131.86,406.56,131.8,406.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,414.47c.06.13-.63.59-1.54,1s-1.71.7-1.78.57.63-.6,1.55-1S131,414.34,131,414.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.91,430.93c-.1.1-.78-.48-1.52-1.29s-1.24-1.53-1.13-1.63.79.48,1.52,1.28S129,430.83,128.91,430.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.59,445.28a11.06,11.06,0,0,1-.72-2.58,11.88,11.88,0,0,1-.61-2.6,8,8,0,0,1,1.33,5.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.94,452.71a6.21,6.21,0,0,1-.08-2.54,6.44,6.44,0,0,1,.44-2.5,12.37,12.37,0,0,1-.36,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.36,436c-.08.12-1-.35-2.06-1.05s-1.86-1.35-1.78-1.47,1,.34,2.06,1S113.44,435.88,113.36,436Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,410.12c-.09.11-.79-.34-1.56-1s-1.32-1.28-1.22-1.39.79.34,1.56,1S125.8,410,125.7,410.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.84,392.49c.1.1-.54.89-1.42,1.76s-1.68,1.51-1.79,1.4.54-.89,1.42-1.77S118.74,392.38,118.84,392.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.36,378.63c.07.13-.54.61-1.36,1.09s-1.55.75-1.62.63.54-.61,1.36-1.09S126.29,378.51,126.36,378.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,442.84c-.13.06-.53-.57-.88-1.39s-.54-1.55-.4-1.61.52.57.88,1.4S118.63,442.78,118.5,442.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,349.53a7.88,7.88,0,0,1-2.8.11,7.57,7.57,0,0,1-2.78-.41,7.88,7.88,0,0,1,2.8-.11A7.51,7.51,0,0,1,87,349.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09,333.44a7.27,7.27,0,0,1-2.6-.79,7,7,0,0,1-2.39-1.26,6.93,6.93,0,0,1,2.59.78A7.41,7.41,0,0,1,86.09,333.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.55,313.48a4.65,4.65,0,0,1-2.79-.75,4.75,4.75,0,0,1-2.2-1.89c.11-.11,1.08.72,2.44,1.43S87.58,313.33,87.55,313.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.24,304.16a7.25,7.25,0,0,1-1.51-2.24,7.16,7.16,0,0,1-1.06-2.49,13.74,13.74,0,0,1,2.57,4.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,301.43a7.78,7.78,0,0,1-1.6,2.34c-1,1.19-1.88,2.09-2,2a7.86,7.86,0,0,1,1.59-2.34C103,302.24,103.85,301.34,104,301.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.19,315.21c.09.12-.77.87-1.91,1.68a6.19,6.19,0,0,1-2.21,1.24c-.08-.11.78-.86,1.91-1.67A6.3,6.3,0,0,1,107.19,315.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.68,334.32a9.93,9.93,0,0,1-4.4,1.17,5.34,5.34,0,0,1,2.14-.83A5.1,5.1,0,0,1,108.68,334.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,350.51a7,7,0,0,1-2.65.12,6.64,6.64,0,0,1-2.63-.4,7.15,7.15,0,0,1,2.65-.12A7.09,7.09,0,0,1,107.8,350.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,366.9a9.23,9.23,0,0,1-2.52,1.69,8.9,8.9,0,0,1-2.77,1.24,9.23,9.23,0,0,1,2.52-1.69A8.9,8.9,0,0,1,108.1,366.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.49,374.86a8.11,8.11,0,0,1-2.84-.33,8,8,0,0,1-2.73-.85,8,8,0,0,1,2.84.34A7.9,7.9,0,0,1,85.49,374.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,389.14c.1.11-.87,1.06-2.16,2.12a9,9,0,0,1-2.5,1.73,9.19,9.19,0,0,1,2.17-2.13A9,9,0,0,1,86,389.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.36,431.77a11.54,11.54,0,0,1-2.8-2,11.58,11.58,0,0,1-2.48-2.4,11.82,11.82,0,0,1,2.81,2A11.35,11.35,0,0,1,86.36,431.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.79,443.79c.1.11-.68.92-1.74,1.81A6.18,6.18,0,0,1,82,447c-.1-.1.68-.92,1.74-1.81A6.18,6.18,0,0,1,85.79,443.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,417c.09.12-.89,1-2.19,2a8.21,8.21,0,0,1-2.51,1.54,8.6,8.6,0,0,1,2.2-2A8.66,8.66,0,0,1,106.89,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.22,396.54a5,5,0,0,1-2.42,1.6,4.82,4.82,0,0,1-2.87.45,25.68,25.68,0,0,1,2.68-.93A24.47,24.47,0,0,1,107.22,396.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.52,381.55a5.49,5.49,0,0,1-2.3-.63,5.8,5.8,0,0,1-2.11-1.12,5.52,5.52,0,0,1,2.3.63A5.8,5.8,0,0,1,107.52,381.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.66,457.52a9.26,9.26,0,0,1-2.68,1.55,9.27,9.27,0,0,1-2.91,1.08,9.53,9.53,0,0,1,2.68-1.55A9.27,9.27,0,0,1,108.66,457.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.81,362.48A12.06,12.06,0,0,1,83,360.32a12.5,12.5,0,0,1-2.46-2.54,12.49,12.49,0,0,1,2.81,2.15A12.34,12.34,0,0,1,85.81,362.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.27,354.86a8.7,8.7,0,0,1-2.35,1.84,8.67,8.67,0,0,1-2.64,1.39,8.78,8.78,0,0,1,2.35-1.83A8.84,8.84,0,0,1,109.27,354.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21,322.87c0,.15-1,.13-2.1,0a4.35,4.35,0,0,1-2-.55,4.37,4.37,0,0,1,2.09,0A4.56,4.56,0,0,1,85.21,322.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,324.05c0,.13-.83.57-2,1a5,5,0,0,1-2.14.49c-.05-.14.83-.58,2-1A4.64,4.64,0,0,1,107.51,324.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.79,359a7.94,7.94,0,0,1-1.56,2.36c-1,1.21-1.86,2.13-2,2A8.05,8.05,0,0,1,93.82,361C94.8,359.81,95.68,358.9,95.79,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77,343.71c-.08.11-1-.46-1.8-1.57a3.46,3.46,0,0,1-.84-2.24c.14,0,.54.91,1.27,1.94S95.86,343.59,95.77,343.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.48,322c.09.12-.72.9-1.52,2s-1.28,2.14-1.42,2.08a4.14,4.14,0,0,1,1-2.39C94.38,322.52,95.4,321.88,95.48,322Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.72,381a4.73,4.73,0,0,1,.48-2.14,5.08,5.08,0,0,1,1-2,4.69,4.69,0,0,1-.49,2.15C94.29,380.15,93.85,381,93.72,381Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.42,412.42a13.77,13.77,0,0,1-1.87-3.25,13.54,13.54,0,0,1-1.39-3.48A13.44,13.44,0,0,1,89,408.94,13.81,13.81,0,0,1,90.42,412.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3,417.34a17,17,0,0,1-1.69,3.78,16.4,16.4,0,0,1-2.16,3.54,17.2,17.2,0,0,1,1.69-3.78A16.25,16.25,0,0,1,96.3,417.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,450.86a12.93,12.93,0,0,1-1.86-3.11,12.43,12.43,0,0,1-1.39-3.34,12.93,12.93,0,0,1,1.86,3.11A12.43,12.43,0,0,1,96,450.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,461.1a7,7,0,0,1-1.25,2.35c-.81,1.21-1.57,2.13-1.69,2.05a7,7,0,0,1,1.26-2.34C93.14,461.94,93.89,461,94,461.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.68,305.67c.72,0,1.3,38,1.3,84.85s-.58,84.86-1.3,84.86-1.3-38-1.3-84.86S98,305.67,98.68,305.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.23,374.17c.35,0,.77,4.33,1,11.36s.18,16.7.37,27.39a66.23,66.23,0,0,1-1.31,15.29,32.39,32.39,0,0,1-2.21,6.45,47.65,47.65,0,0,1-2.85,5.12,12.24,12.24,0,0,1-3.47,3.63,11.89,11.89,0,0,1-3.43,1.5c-2,.51-3.06.52-3.09.37s1-.55,2.75-1.32a13,13,0,0,0,2.91-1.73,11.65,11.65,0,0,0,2.77-3.42,53.24,53.24,0,0,0,2.44-5.05,31.21,31.21,0,0,0,1.83-6.06A72.2,72.2,0,0,0,121,413c-.19-10.72.15-20.43.39-27.43S121.86,374.18,122.23,374.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M658.8,395.58a13.56,13.56,0,0,1-7-7c-.55-1.29-.57-3.28.81-3.57.84-.17,1.6.48,2.21,1.09l6.12,6.06a12.8,12.8,0,0,1,.42-9.94c.52-1.1,1.61-2.27,2.75-1.85.9.33,1.19,1.44,1.35,2.39q.74,4.38,1.46,8.76a21.22,21.22,0,0,1,4.81-9.18c.85-1,2.21-1.87,3.29-1.19s.9,2,.7,3.07a44.08,44.08,0,0,1-2.3,8,15.13,15.13,0,0,1,9.51-3.77,3.33,3.33,0,0,1,2.81.91c.95,1.19.12,3-.89,4.11-3,3.39-10,4.26-14.54,4",
    style: {
      fill: "#F16920"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.85,402.79c-11-8.62-30.19-9.84-42.86-4-14.31,6.55-23.68,21.78-25.07,36.37-1.33,13.87,5.35,27.94,11,40.66l55.29.26c6.63-11,13.53-23.23,14-36S695.92,410.72,685.85,402.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.05,395.18l-.25.08-.72.16-1.18.26a10.43,10.43,0,0,0-1.58.42,31.54,31.54,0,0,0-9.37,4.48,42.18,42.18,0,0,0-10.66,11.08,62.35,62.35,0,0,0-4.47,8,71,71,0,0,0-3.44,9.19,42.09,42.09,0,0,0-.93,18.74,81,81,0,0,0,4.16,14.91c1.54,4.15,2.9,7.46,3.81,9.77.43,1.12.78,2,1,2.65.1.29.19.51.26.7s.07.24.07.24,0-.07-.12-.22l-.31-.68c-.27-.63-.64-1.51-1.12-2.62-1-2.28-2.38-5.57-4-9.71a78.35,78.35,0,0,1-4.3-15,42.19,42.19,0,0,1,.91-19,70.94,70.94,0,0,1,3.47-9.26,63.26,63.26,0,0,1,4.54-8,41.89,41.89,0,0,1,10.86-11.11,30.36,30.36,0,0,1,9.52-4.38,10,10,0,0,1,1.6-.37l1.19-.21.73-.12A1,1,0,0,1,661.05,395.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.15,475.6a8.43,8.43,0,0,1,.26-.83l.83-2.33c.72-2,1.78-4.95,3-8.59s2.63-8,3.84-12.92a83.91,83.91,0,0,0,2.46-16.27,56.32,56.32,0,0,0-1.69-16.32A44.36,44.36,0,0,0,680.68,406a35.7,35.7,0,0,0-5.65-7.06c-.74-.78-1.42-1.27-1.83-1.66a5.41,5.41,0,0,1-.63-.6,6,6,0,0,1,.7.51c.43.37,1.13.84,1.9,1.6a34.35,34.35,0,0,1,5.82,7,43.94,43.94,0,0,1,5.35,12.42,56.18,56.18,0,0,1,1.74,16.46,83,83,0,0,1-2.51,16.37c-1.24,4.94-2.68,9.3-4,12.93s-2.4,6.53-3.18,8.53c-.39,1-.7,1.73-.92,2.3A4.53,4.53,0,0,1,677.15,475.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.47,395.5a4.52,4.52,0,0,1-.22.81c-.17.57-.41,1.33-.71,2.29s-.71,2.21-1.13,3.63-.92,3-1.41,4.82c-1,3.58-2.12,7.88-3.22,12.68s-2.08,10.12-2.92,15.73-1.36,11-1.7,15.92c-.13,2.46-.29,4.79-.31,7,0,1.09-.05,2.15-.07,3.16s0,2,0,2.92c0,1.87.07,3.55.12,5s.11,2.75.19,3.79.1,1.8.14,2.39a4.12,4.12,0,0,1,0,.84,6.47,6.47,0,0,1-.12-.83c0-.59-.13-1.39-.24-2.39s-.21-2.31-.27-3.79-.19-3.16-.2-5c0-.93,0-1.91,0-2.93s0-2.08,0-3.17c0-2.2.15-4.54.26-7,.31-4.93.84-10.33,1.66-16s1.89-11,3-15.77,2.25-9.1,3.33-12.67c.51-1.8,1-3.4,1.49-4.81s.85-2.62,1.21-3.6.6-1.7.81-2.26A5.26,5.26,0,0,1,666.47,395.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.68,439.54a17.78,17.78,0,0,1-3.78,2,18,18,0,0,1-4,1.54,17.3,17.3,0,0,1,3.77-2A17.59,17.59,0,0,1,619.68,439.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.43,423.65a41.63,41.63,0,0,1-8-4.65,20.27,20.27,0,0,1,4.15,2.1A20.5,20.5,0,0,1,621.43,423.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.52,410.53a26.79,26.79,0,0,1-3.19-6.72,26.79,26.79,0,0,1,3.19,6.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.38,398.14a9.35,9.35,0,0,1-2-2.27,9.18,9.18,0,0,1-1.59-2.58,8.9,8.9,0,0,1,2,2.27A8.64,8.64,0,0,1,645.38,398.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.94,458.94a19.42,19.42,0,0,1-3.87,2.39,19.74,19.74,0,0,1-4.12,1.93,40.25,40.25,0,0,1,8-4.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.45,449.28a30.25,30.25,0,0,1-6.81-3.82,14.34,14.34,0,0,1,3.53,1.68A14.51,14.51,0,0,1,642.45,449.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.05,427.2a16.3,16.3,0,0,1-7.13,2.79,21.55,21.55,0,0,1,3.54-1.46A23.35,23.35,0,0,1,647.05,427.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.3,410.56a6.63,6.63,0,0,1-1.43-2.7,6.43,6.43,0,0,1-.54-3,15.36,15.36,0,0,1,1,2.84A14.76,14.76,0,0,1,652.3,410.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.58,470.94a31.35,31.35,0,0,1,3.44-7.2,15.39,15.39,0,0,1-1.48,3.72A15.24,15.24,0,0,1,640.58,470.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.45,465a11.77,11.77,0,0,1-3.23-2.89,11.47,11.47,0,0,1-2.35-3.64c.13-.08,1.21,1.51,2.75,3.3A40.91,40.91,0,0,1,668.45,465Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.11,440.71a20,20,0,0,1-3.85,2.51,21.25,21.25,0,0,1-4.12,2.06,20.33,20.33,0,0,1,3.86-2.51A21,21,0,0,1,678.11,440.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.61,425.76a18.11,18.11,0,0,1,3-3.18,18.8,18.8,0,0,1,3.34-2.8,35.88,35.88,0,0,1-6.33,6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.91,409.89a13,13,0,0,1-3-2.14,13.26,13.26,0,0,1-2.72-2.54,26.74,26.74,0,0,1,5.77,4.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.33,399.4a28,28,0,0,1-6.34,4.13,27.14,27.14,0,0,1,6.34-4.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.43,413.94a20,20,0,0,1-6.36.45,19.25,19.25,0,0,1,6.36-.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.06,431.13a15.58,15.58,0,0,1-4-.13,16,16,0,0,1-4-.64,15.37,15.37,0,0,1,4,.12A16,16,0,0,1,702.06,431.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.77,453.3a24,24,0,0,1-3.71-3.38,23.78,23.78,0,0,1-3.33-3.74,49.36,49.36,0,0,1,7,7.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.72,470.38a17,17,0,0,1-3.74-3.62,16.73,16.73,0,0,1-2.89-4.33c.13-.08,1.46,1.81,3.29,4S693.82,470.27,693.72,470.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M672.57,396.68c.09-.14,1.19.39,3,1.63a31.31,31.31,0,0,1,6.67,6.54,37.24,37.24,0,0,1,6.11,12.49,58.86,58.86,0,0,1,2.06,16.82,71.61,71.61,0,0,1-2.26,16.76,89.42,89.42,0,0,1-4.41,13c-3.09,7.18-5.68,11.26-6,11.11s1.64-4.54,4.24-11.78,5.66-17.5,5.78-29.13A61.91,61.91,0,0,0,686,418a38.76,38.76,0,0,0-5.29-12.05,40.19,40.19,0,0,0-5.81-6.83C673.36,397.66,672.46,396.84,672.57,396.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M666.07,394.68c.36.08-.36,4.64-1.72,12S661,424,659.28,435.19c-.85,5.59-1.51,10.93-2,15.8-.21,2.43-.45,4.75-.58,6.92s-.26,4.19-.35,6c-.32,7.39-.25,12-.65,12s-1-4.56-1.19-12.05c0-1.87,0-3.92,0-6.12s.19-4.55.34-7c.37-4.93,1-10.34,1.81-16,1.74-11.28,4-21.33,5.85-28.56S665.72,394.61,666.07,394.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M659.59,394.11c0,.19-1.22.68-3.45,1.69a51.47,51.47,0,0,0-8.9,5.11,45.33,45.33,0,0,0-18.06,27.35,47,47,0,0,0-1,9.47,58,58,0,0,0,.67,8.91,94.11,94.11,0,0,0,3.64,14.83c1.35,4.16,2.6,7.5,3.42,9.82s1.22,3.64,1,3.71-.87-1.1-2-3.31-2.63-5.46-4.23-9.61A81,81,0,0,1,626.44,447a57.16,57.16,0,0,1-.85-9.29,46.94,46.94,0,0,1,1-10,46.1,46.1,0,0,1,8-17.6,44.22,44.22,0,0,1,11.56-10.73,40.2,40.2,0,0,1,9.57-4.53C658.17,394.12,659.54,394,659.59,394.11Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg400);
export default __webpack_public_path__ + "static/media/400.329b1fa3f6b346e130e939e034061b56.svg";
export { ForwardRef as ReactComponent };